import axiosInstance from '../../config/axiosConfig';
import { urlAmenazas } from '../../config/apiURL';
import { extractArray, extractDataObject } from '../utils/responseHelpers';

// Obtener todas las amenazas
export async function getAmenazasPorEmpresa(emp_codigo) {
  try {
    const response = await axiosInstance.get(`${urlAmenazas}/empresa/${emp_codigo}`);
    return extractArray(response);
  } catch (error) {
    console.error('Error fetching amenazas:', error);
    throw error;
  }
}

// Obtener una amenaza por ID
export async function getAmenazaPorId(id) {
  try {
    const response = await axiosInstance.get(`${urlAmenazas}/${id}`);
    return extractDataObject(response);
  } catch (error) {
    console.error('Error fetching amenaza:', error);
    throw error;
  }
}

// Create a new threat
export async function createAmenaza(data) {
  try {
    const response = await axiosInstance.post(urlAmenazas, data);
    return extractDataObject(response);
  } catch (error) {
    console.error('Error creating amenaza:', error);
    throw error;
  }
}

// Update an existing threat
export async function updateAmenaza(id, data) {
  try {
    const response = await axiosInstance.put(`${urlAmenazas}/${id}`, data);
    return extractDataObject(response);
  } catch (error) {
    console.error(`Error updating amenaza ${id}:`, error);
    throw error;
  }
}

// Delete a threat
export async function deleteAmenaza(id) {
  try {
    const response = await axiosInstance.delete(`${urlAmenazas}/${id}`);
    return extractDataObject(response);
  } catch (error) {
    console.error(`Error deleting amenaza ${id}:`, error);
    throw error;
  }
}